export default "__VITE_ASSET__D5tkXJ7t__"